import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Machine } from 'src/app/model/machine/machine.model';
import { MachineService } from 'src/app/services/http/machine/machine.service';

@Component({
  selector: 'app-machine',
  templateUrl: './machine.component.html',
  styleUrls: ['./machine.component.scss']
})
export class MachineComponent implements OnInit {

  constructor(private service: MachineService, private activatedRoute: ActivatedRoute) { }

  public identifiant !: string;
  public machine !: Machine;

  ngOnInit(): void {

    const params = this.activatedRoute.snapshot.params
    this.identifiant = params.id;

    this.service.getMachine(this.identifiant)
      .subscribe((machine) => {
        this.machine = machine;
      });
    
  }

}
